import { useTranslation } from 'next-i18next';

import { itemListProps } from '@restworld/utils-common';

import { Wrapper, SecondaryList } from '../..';
import { Heading } from '@restworld/ui-ds-base';

export const JobOfferBenefits = ({ jobBenefits }: JobOfferBenefitsProps) => {
  const { t } = useTranslation('job-position-page');
  return (
    <Wrapper>
      <Heading as="span" size={5} weight="semibold" className="text-gray-900">
        {t('job_offer_title')}
      </Heading>
      <SecondaryList itemList={jobBenefits} orientation="vertical" textColor="gray" />
    </Wrapper>
  );
};
export default JobOfferBenefits;
export interface JobOfferBenefitsProps {
  jobBenefits: itemListProps[];
}
